<template>
  <a
    ref="container"
    href="javascript:void(0)"
    class="play-camera cursor-zoom"
    aria-label="Открыть видео"
    @click="$vfm.show({ component: 'PopupLive' })"
  >
    <div ref="words" class="play-camera__words" />
    <div class="play-camera__icon"><Icon icon="live" /></div>
  </a>
</template>

<script>
import { gsap } from "gsap";

export default {
  mounted() {
    const container = this.$refs.container;
    const words = this.$refs.words;
    const rotationTL = gsap.to(words, {
      rotation: "360",
      duration: 30,
      ease: "none",
      repeat: -1,
    });
    container.addEventListener("mouseenter", () => rotationTL.pause());
    container.addEventListener("mouseleave", () => rotationTL.resume());
  },
};
</script>

<style scoped>
.play-camera {
  --size: 178px;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--size);
  height: var(--size);
}

.play-camera__icon {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 74px;
  height: 74px;
  border-radius: 50%;
  background: linear-gradient(105.18deg, #d3d0ff 0%, #ff0020 50%, #ffffff 100%);
}

.play-camera__icon svg {
  width: 40%;
  height: auto;
  max-height: 100%;
}

body.-notouch .play-camera:hover .play-camera__icon {
  background: linear-gradient(180deg, #b8b4e0, #d9001a, #d6d6d6);
}

body.-notouch .play-camera:active .play-camera__icon {
  background: linear-gradient(180deg, #b8b4e0, #d9001a, #d6d6d6);
}

.play-camera__words {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: url("~@i/play-btn-words.png") 0 0 no-repeat;
  background-size: cover;
}

@media (max-width: 767px) {
  .play-camera__icon {
    width: 50px;
    height: 50px;
  }
}
</style>
